var _style, _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcalLogoGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 535.4 170.6",
    style: {
      enableBackground: "new 0 0 535.4 170.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 6.8,
    y: 5.8,
    width: 520.2,
    height: 161.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#696969",
    d: "M495.4,163.8H527V5.8h-31.6V163.8z M322.1,83c0.5-5.4,2-8.8,5.4-11.7c3.8-3.2,9.3-4.7,16-4.7 c12.9,0,19.6,5.2,19.6,13.8c0,6.3-2.5,9.3-10.8,10.4l-5.2,0.7c-24.8,3.6-59.4,8.4-59.4,39c0,22.6,19.4,36.6,44.2,36.6 c20.3,0,29.3-7.2,34.8-12.4h0.2l0.7,9.3h28.7v-0.7c-2-3.6-2.7-7.7-2.7-15.3V93.6c0-11.1-0.9-18.1-2.7-23.7 c-6.1-19.2-26.4-25.7-46.5-25.7c-28.2,0-49.4,12-51,38.6L322.1,83z M338.6,144.4c-12,0-19.4-5.2-19.4-14.9c0-3.6,1.4-6.8,3.6-9 c3.2-3.2,9.3-5.2,17.8-7.4l7-1.8c8.1-2,14-3.6,16.7-4.7v14.1c0,5.6-0.5,7.7-1.1,9.7C359.5,140.6,348.7,144.4,338.6,144.4  M242.6,86.4C239.4,60.9,218.5,44,189.3,44c-36.8,0-59.6,25.5-59.6,61.4c0,36.8,21.2,61.4,59.4,61.4c30.2,0,49.9-17.2,54.4-42.4 h-30.7c-2.7,9.3-8.6,18.1-23,18.1c-16.5,0-27.5-11.3-27.5-36.8c0-24.4,10.6-37.5,26.9-37.5c13.5,0,20.5,9,22.3,18.3h31.1V86.4z  M65.3,67c15.8,0,25.5,11.1,26,26H39.4C40.7,78.1,50.1,67,65.3,67 M89.6,130c-3.4,6.3-10.2,12.6-22.8,12.6 c-14.4,0-26.4-8.6-28-28.9H123v-2.9C123,72.7,104,44,65.2,44C29.5,44,6.7,70.4,6.7,105.4s21.7,61.4,59.6,61.4 c28,0,47.2-14.7,55.3-36.8H89.6z M101.4,5.8H63L47.7,34.9h28.2L101.4,5.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcalLogoGrey);
export default __webpack_public_path__ + "static/media/ecal_logo_grey.945f09cb31be9c9b3a53ea710a49837a.svg";
export { ForwardRef as ReactComponent };